import React, { useState, useEffect, useCallback } from "react";
import { Select, StatusLabel } from "../../CoreUI";
import "./product-variant-selector.css";

const ProductVariantSelector = React.memo(
	({ variantData, handleVariantChange, ...props }) => {
		if (
			!variantData ||
			typeof variantData !== "object" ||
			Object.entries(variantData).length === 0 ||
			variantData.single_variant
		) {
			return;
		}

		const [selected, setSelected] = useState(null);
		const [selectOptions, setSelectOptions] = useState({});
		const [selectOptionsStock, setSelectOptionsStock] = useState([]);

		const handleChange = useCallback(({ target: { value } }) => {
			setSelected(value);
		}, []);

		useEffect(() => {
			if (
				selected &&
				variantData &&
				variantData[selected] &&
				variantData[selected].variant_id
			) {
				handleVariantChange(variantData[selected]);
			}
		}, [variantData, selected, handleVariantChange]);

		useEffect(() => {
			setSelected(
				Object.entries(variantData).filter(
					([key, item]) =>
						key &&
						key !== "variant_type" &&
						item &&
						!item.out_of_stock
				)?.[0]?.[0] || ""
			);
			setSelectOptionsStock(
				Object.entries(variantData)
					.filter(([key]) => key !== "variant_type")
					.map(([, item]) => item.out_of_stock)
			);

			return setSelectOptions(
				Object.entries(variantData)
					.filter(([key]) => key !== "variant_type")
					.reduce(
						(map, [key]) => ({
							...map,
							[key]: key,
						}),
						{}
					)
			);
		}, [variantData]);

		if (selected === null) {
			// if (selected === null || !variantData || !variantData[selected]) {
			return;
		}

		if (selected === "") {
			return (
				<section className="offer-card-variant-error-container">
					<StatusLabel className="offer-card-variant-error">
						Out of Stock
					</StatusLabel>
					{/* <span>
						Please remove this offer or update your inventory
					</span> */}
				</section>
			);
		}

		return (
			<>
				{Object.entries(selectOptions).length > 0 && (
					<section className="offer-card-variant-selector" {...props}>
						<Select
							multiple={false}
							value={selected}
							label={
								(variantData &&
									variantData[selected] &&
									variantData[selected].variant_type) ||
								"Choose One"
							}
							onChange={handleChange}
							options={selectOptions}
							variantSelector
							variantStock={selectOptionsStock}
						/>
					</section>
				)}
				{variantData &&
					variantData[selected] &&
					!variantData[selected].variant_id && (
						<ProductVariantSelector
							variantData={variantData[selected]}
							handleVariantChange={handleVariantChange}
							{...props}
						/>
					)}
			</>
		);
	}
);

export default ProductVariantSelector;
